import styled from "styled-components";
import { theme } from "ui";

export const SkeletonContainer = styled.section`
  display: flex;
  flex-wrap: wrap;
  gap: ${theme.space.x4};
  justify-content: center;
`;
